const isSubscribed = getQueryParam("customer_posted") === "true";

document.addEventListener("DOMContentLoaded", () => {
  initProviderSwitch();
  initTabSwitch();
  initNewsletter();
  loadData();
});

/** ---------------- 工具函数 ---------------- **/

function getQueryParam(param, defaultValue = null) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param) ?? defaultValue;
}

function parseField(str) {
  if (!str) return { field: "", value: "" };
  const [field, value] = str.split(":");
  return { field: field?.trim(), value: value?.trim() };
}

function getStatusClass(num) {
  if (num > 20) return "error";
  if (num > 10) return "warning";
  return "";
}

function setActive(elements, index = 0) {
  elements.forEach(el => el.classList.remove("active"));
  if (elements[index]) elements[index].classList.add("active");
}

/** ---------------- Provider 切换 ---------------- **/
function initProviderSwitch() {
  const providerListBox = document.querySelector(".provider-list");
  if (!providerListBox) return;

  providerListBox.addEventListener("click", (e) => {
    const provider = e.target.closest(".provider");
    if (!provider) return;

    const providers = providerListBox.querySelectorAll(".provider");
    const cardLists = document.querySelectorAll(".com-list .cards-list");
    const tabs = document.querySelectorAll(".tabs .tab");

    // 计算点击的 index
    const pIndex = Array.from(providers).indexOf(provider);

    // 高亮 provider
    providers.forEach(p => p.classList.remove("active"));
    provider.classList.add("active");

    // 切换对应的 cards-list
    cardLists.forEach(list => list.classList.remove("active"));
    const activeList = cardLists[pIndex];
    if (activeList) {
      activeList.classList.add("active");

      // 重置 tab
      tabs.forEach(t => t.classList.remove("active"));
      if (tabs[0]) tabs[0].classList.add("active");

      const cardsGroups = activeList.querySelectorAll(".cards");
      cardsGroups.forEach(c => c.classList.remove("active"));
      if (cardsGroups[0]) cardsGroups[0].classList.add("active");
    }

    // 更新圆圈数字
    if (window._providerData) updateNumStatus(window._providerData[pIndex]);
  });
}

/** ---------------- Tab 切换 ---------------- **/

function initTabSwitch() {
  const tabs = document.querySelectorAll(".tabs .tab");

  tabs.forEach((tab, tIndex) => {
    tab.addEventListener("click", () => {
      setActive(tabs, tIndex);

      const activeList = document.querySelector(".com-list .cards-list.active");
      if (!activeList) return;

      const cardsGroups = activeList.querySelectorAll(".cards");
      setActive(cardsGroups, tIndex);
    });
  });
}

/** ---------------- 邮箱订阅 ---------------- **/

function initNewsletter() {
  const form = document.getElementById("newsletter_form");
  const successBox = document.getElementById("newsletter-success");
  if (!form || !successBox) return;

  if (isSubscribed) {
    form.style.display = "none";
    successBox.style.display = "block";
  }

  form.addEventListener("submit", e => {
    e.preventDefault();

    const currentParams = window.location.search;
    fetch(form.action, { method: "POST", body: new FormData(form) })
      .then(() => {
        const newUrl =
          window.location.pathname +
          (currentParams
            ? `${currentParams}&customer_posted=true#newsletter_form`
            : "?customer_posted=true#newsletter_form");
        window.location.href = newUrl;
      });
  });
}

/** ---------------- 数据加载 ---------------- **/

function loadData() {
  const zipcode = getQueryParam("zip", "98001");
  if (!zipcode) return console.warn("URL 中没有 zipcode 参数");

  fetch(`https://simpure.mscn.tech/api/customer/water-report/provider-list?zip=${zipcode}&isSubscribed=${isSubscribed}`)
    .then(res => res.json())
    .then(resp => {
      if (!resp.success) {
        return console.warn("水质报告获取失败：" + resp.message);
      }

      const data = resp.data;
      window._providerData = data.providerList;

      renderZipAndStatus(data);
      renderProviders(data.providerList);
      renderComLists(data.providerList);

      //显示 wait-loading 的 dom
      document.querySelectorAll(".wait-loading").forEach(el => {
        el.style.display = "block";
      });
    }).catch(err => console.error("获取水质数据失败", err));
}

function renderZipAndStatus(data) {
  const zipCodeDoms = document.querySelectorAll(".report-box .zip-code");
  zipCodeDoms.forEach(dom => {
    dom.textContent = data.zip;
  });
  updateNumStatus(data.providerList[0]);
}

function renderProviders(providerList) {
  const providerListBox = document.querySelector(".provider-list");
  if (!providerListBox) return;

  providerListBox.innerHTML = "";
  providerList.forEach((p, idx) => {
    const btn = document.createElement("button");
    btn.className = "provider" + (idx === 0 ? " active" : "");
    btn.textContent = p.serverName || `Provider ${idx + 1}`;
    providerListBox.appendChild(btn);
  });
}

function renderComLists(providerList) {
  const comList = document.querySelector(".com-list");
  if (!comList) return;
  comList.innerHTML = "";

  providerList.forEach((provider, pIndex) => {
    const listDiv = document.createElement("div");
    listDiv.className = "cards-list" + (pIndex === 0 ? " active" : "");

    [provider.contaminantListOfStandard || [], provider.contaminantListOfOther || []].forEach((group, gIndex) => {
      const cardsDiv = document.createElement("div");
      cardsDiv.className = "cards" + (gIndex === 0 ? " active" : "");

      group.forEach(cont => cardsDiv.appendChild(createCard(cont, gIndex)));
      listDiv.appendChild(cardsDiv);
    });

    comList.appendChild(listDiv);
  });
}

function createCard(cont, gIndex) {
  const card = document.createElement("div");
  card.className = "card";

  const potentialEffect = parseField(cont.potentialEffect);
  const thisUtility = parseField(cont.thisUtility);
  const healthGuideline = parseField(cont.healthGuideline);
  const legalLimit = parseField(cont.legalLimit);

  if (gIndex === 0) {
    card.innerHTML = `
      <h3>${cont.contaminant || "-"}</h3>
      <div class="line"><p class="key">Contaminant</p><p class="value">${potentialEffect.field || "-"}: ${potentialEffect.value || "-"}</p></div>
      <div class="high-line"><p class="value">${cont.greater || "-"}</p><p class="guideline">EWG Health Guidelines</p></div>
      ${renderLine(thisUtility)}
      ${renderLine(healthGuideline, true)}
      ${renderLine(legalLimit, true)}
    `;
  } else {
    card.innerHTML = `
      <div class="line"><p class="key">Contaminant</p><p class="value">${cont.contaminant || "-"}</p></div>
      ${renderLine(thisUtility)}
      ${renderLine(healthGuideline, true)}
      ${renderLine(legalLimit, true)}
    `;
  }

  return card;
}

function renderLine({ field, value }, allowEmpty = false) {
  if (!value && allowEmpty) {
    return `<div class="line"><p class="key no-val">${field || "-"}</p></div>`;
  }
  return `<div class="line"><p class="key">${field || "-"}</p><p class="value">${value || "-"}</p></div>`;
}

function updateNumStatus(currentProvider) {
  if (!currentProvider) return console.warn("未找到当前服务商");

  const circleNumDom = document.querySelector(".circle-report .circle");
  const exceedNumDom = document.querySelector(".circle-report .exceed");
  const totalNumDom = document.querySelector(".circle-report .total");
  const circleReportDom = document.querySelector(".report-box .circle-report");
  
  const le10Dom = document.querySelector(".le_10");
  const gt10Dom = document.querySelector(".gt_10");

  const standard = currentProvider.contaminantNumOfStandard || 0;
  const other = currentProvider.contaminantNumOfOther || 0;

  if (circleNumDom) circleNumDom.textContent = standard;
  if (exceedNumDom) exceedNumDom.textContent = standard;
  if (totalNumDom) totalNumDom.textContent = standard + other;

  circleReportDom?.classList.remove("warning", "error");
  const cls = getStatusClass(standard);
  if (cls) circleReportDom.classList.add(cls);
  if (le10Dom && gt10Dom) {
    const showLe10 = standard <= 10; // true 表示显示 le10
    le10Dom.style.display = showLe10 ? "block" : "none";
    gt10Dom.style.display = showLe10 ? "none" : "block";
}
}
